import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _fillInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/fill';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import React, { memo } from 'react';

var _excluded = ["fill", "fill2"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function IcNFLogo(customProps) {
  var fill = _fillInstanceProperty(customProps),
    fill2 = customProps.fill2,
    props = _objectWithoutProperties(customProps, _excluded);
  return /*#__PURE__*/React.createElement("svg", _objectSpread({
    width: "100%",
    height: "100%",
    viewBox: "0 0 96 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.8125V25.1875H3.50903V21.327H6.95239L7.954 18.6484H3.50903V16.6912H8.68554L9.76271 13.8125H0Z",
    fill: fill2 || '#AAAAAC'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3899 25.1875H14.6441V13.8125H11.3899V25.1875Z",
    fill: fill2 || '#AAAAAC'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.808 13.8125V19.9003L20.5849 13.8125H17.0847V25.1875H20.7519V19.0997L24.9744 25.1875H28.4745V13.8125H24.808Z",
    fill: fill2 || '#AAAAAC'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.3389 25.1875H71.5931V13.8125H68.3389V25.1875Z",
    fill: fill2 || '#AAAAAC'
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2364_21840",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 13,
    width: 12,
    height: 13
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8296 13.6853H66.8702V25.1876H55.8296V13.6853Z",
    fill: fill || 'white'
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2364_21840)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.8296 19.4677V19.4369C55.8296 16.1436 58.4229 13.6853 61.7479 13.6853C64.1975 13.6853 65.8517 14.8666 66.7908 16.5529L63.72 18.3337C63.3068 17.5453 62.7181 16.9943 61.6996 16.9943C60.4427 16.9943 59.6162 18.0812 59.6162 19.4048V19.4369C59.6162 20.8707 60.4751 21.8788 61.6996 21.8788C62.7499 21.8788 63.3386 21.3114 63.8001 20.4922L66.8702 22.2094C65.9318 23.8485 64.373 25.1878 61.6042 25.1878C58.5182 25.1878 55.8296 22.8876 55.8296 19.4677Z",
    fill: fill2 || '#AAAAAC'
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5916 20.842L35.8364 17.3964L37.0806 20.842H34.5916ZM33.8713 13.9211L29.5049 24.9514H33.2165L33.7435 23.4918H37.9287L38.4558 24.9514H42.1673L37.8009 13.9211H33.8713Z",
    fill: fill2 || '#AAAAAC'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.4877 22.1598V13.9216H86.8855V24.9512H94.6164L95.7213 22.1598H90.4877Z",
    fill: fill2 || '#AAAAAC'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1635 20.842L79.4083 17.3964L80.6531 20.842H78.1635ZM77.4432 13.9211L73.0774 24.9514H76.7883L77.316 23.4918H81.5006L82.0276 24.9514H85.7392L81.3728 13.9211H77.4432Z",
    fill: fill2 || '#AAAAAC'
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8998 19.8246L46.7521 13.9213H43.3132V24.9515H46.9155V19.0482L51.0632 24.9515H54.502V13.9213H50.8998V19.8246Z",
    fill: fill2 || '#AAAAAC'
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2364_21840",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.0378418H11.1888V11.068H0V0.0378418Z",
    fill: fill || 'white'
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2364_21840)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58654 5.94104L3.43883 0.0377197H0V11.068H3.60223V5.16464L7.74993 11.068H11.1888V0.0377197H7.58654V5.94104Z",
    fill: fill2 || '#AAAAAC'
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2364_21840",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 0,
    width: 13,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3352 0.0378418H24.997V11.0678H12.3352V0.0378418Z",
    fill: fill || 'white'
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2364_21840)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4213 6.95849L18.6661 3.51284L19.9109 6.95849H17.4213ZM16.701 0.0375977L12.3352 11.0678H16.0461L16.5738 9.60822H20.7584L21.2855 11.0678H24.997L20.6306 0.0375977H16.701Z",
    fill: fill2 || '#AAAAAC'
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2364_21840",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 36,
    y: 0,
    width: 10,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8953 0.0378418H45.6821V11.0679H36.8953V0.0378418Z",
    fill: fill || 'white'
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2364_21840)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4428 6.87726H45.5187V4.22817H40.4428V2.74148H45.5734V0.0375977H36.8953V11.0678H45.6821V8.36396H40.4428V6.87726Z",
    fill: fill2 || '#AAAAAC'
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2364_21840",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 0,
    width: 13,
    height: 12
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0869 0.0378418H35.7487V11.0678H23.0869V0.0378418Z",
    fill: fill || 'white'
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2364_21840)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4178 7.29022L26.7979 0.0374756H23.0869L27.4533 11.0677H31.3823L35.7487 0.0374756H32.0378L29.4178 7.29022Z",
    fill: fill2 || '#AAAAAC'
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7774 5.17432H50.8675V2.84952H52.7774C53.4258 2.84952 53.951 3.36964 53.951 4.01192C53.951 4.65357 53.4258 5.17432 52.7774 5.17432ZM55.2022 7.28378L55.5398 7.14399C56.8335 6.60749 57.4922 5.44635 57.4922 3.97288C57.4922 2.57938 56.9785 1.54921 55.967 0.909451C55.0267 0.315026 53.8073 0.0379639 52.1289 0.0379639H47.4287V11.0676H50.9216V7.98588H52.1772L54.3057 11.0676H58.0173L55.2022 7.28378Z",
    fill: fill2 || '#AAAAAC'
  }));
}
var IcNFLogo$1 = /*#__PURE__*/memo(IcNFLogo);

export { IcNFLogo$1 as default };
